<header class="content-header">
    <nav class="breadcrumb">
        <a *ngIf="item" [routerLink]="['/applications', item.Number, 'person'] | localize" class="bc-back">
            {{'applications_edit_titlePrefix' | translate}}
            "{{item.AdmissionTitle}}", {{item.Number}}
        </a>
    </nav>
    <h1 [translate]="'modif_title_ApplicationExams'"></h1>
</header>

<ngx-datatable #grid
               class="tight"
               [rows]="gridItems"
               [headerHeight]="'auto'"
               [footerHeight]="50"
               [rowHeight]="'auto'"
               [columnMode]="'flex'"
               [limit]="100"
               [externalSorting]="true"
               [loadingIndicator]="gridLoading"
               [messages]="{ emptyMessage: 'gridEmpty' | translate, totalMessage: 'gridTotal' | translate }"
               (sort)="onGridSort($event)">

    <ngx-datatable-column [width]="20"
                          [resizeable]="false"
                          [sortable]="false"
                          [draggable]="false"
                          [canAutoResize]="false"
                          [flexGrow]="1">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a href="javascript:void(0)"
               [class.datatable-icon-right]="!expanded"
               [class.datatable-icon-down]="expanded"
               (click)="grid.rowDetail.toggleExpandRow(row)">
            </a>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [name]="'modif_lblModified' | translate" prop="Modified" [flexGrow]="1">
        <ng-template ngx-datatable-cell-template let-row="row">
            {{row.Modified | appDate:'+'}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [name]="'modif_lblAction' | translate" prop="ModifAction" [flexGrow]="1">
        <ng-template ngx-datatable-cell-template let-row="row">
            {{'modif_action_' + row.ModifAction | translate}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [name]="'modif_lblUser' | translate" prop="ModifiedByName" [flexGrow]="1"></ngx-datatable-column>
    <ngx-datatable-column [name]="'applications_lblExam' | translate" prop="Exam" [flexGrow]="1"></ngx-datatable-column>
    <ngx-datatable-column [name]="'applications_lblProgramCode' | translate" prop="ProgramCode" [flexGrow]="1"></ngx-datatable-column>

    <ngx-datatable-row-detail [rowHeight]="'auto'" #detailRow>
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <mat-checkbox [ngClass]="{'app-hide-unchanged': !showUnchanged.checked }" #showUnchanged>{{ 'modif_show_unchanged' | translate }}</mat-checkbox>
            <div [ngClass]="{ 'app-differ': row.hasChanged('Grade') }"><label [translate]="'applications_lblGrade'"></label> {{row.Grade}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('Status') }"><label [translate]="'applications_lblStatus'"></label> {{row.Status}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('AuxType') }"><label [translate]="'applications_lblExamAuxType'"></label> {{row.AuxType}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('PreApprovalGrade') }"><label [translate]="'applicationExams_preApprovalGrade'"></label> {{row.PreApprovalGrade}}</div>
        </ng-template>
    </ngx-datatable-row-detail>

</ngx-datatable>
